import React from 'react';
import { ThumbnailContainer, ThumbnailImage, DefaultThumbnailIcon, ThumbnailItem, DEFAULT_CONTAINER_SIZE, StyledAttachmentTypeIcon, StyledWarningIcon } from './style';
const getFontSize = (size) => {
    const containerSize = size || DEFAULT_CONTAINER_SIZE;
    return Number(containerSize.replace(/\D+/g, '')) * 0.6;
};
export const Thumbnail = (props) => {
    return (React.createElement(ThumbnailContainer, { id: `thumbnail-container-${props.id}`, container: true, onClick: props.onClick, style: {
            height: props.height,
            width: props.width
        }, className: props.className },
        React.createElement(ThumbnailItem, { item: true },
            props.defaultIcon ? (React.createElement(DefaultThumbnailIcon, { id: `thumbnail-icon-${props.id}`, style: { fontSize: getFontSize(props.width) }, className: props.defaultIcon })) : (React.createElement(ThumbnailImage, { id: `thumbnail-image-${props.id}`, src: props.url, onError: ({ currentTarget }) => {
                    if (props.defaultImg) {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src = props.defaultImg;
                    }
                }, isPrimaryImage: props.isPrimaryImage })),
            props.attachmentTypeIcon && (React.createElement(StyledAttachmentTypeIcon, { id: `thumbnail-image-pdf-tag-${props.id}`, className: props.attachmentTypeIcon })),
            props.warningTypeIcon && (React.createElement(StyledWarningIcon, { id: `thumbnail-warning-icon-${props.id}`, className: props.warningTypeIcon })))));
};
//# sourceMappingURL=Thumbnail.js.map